import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

function Ul({ ulClassName, liClassName, liValues }) {
  const location = useLocation();
  return (
    <ul className={ ulClassName }>
      {
        location.pathname === '/'
          ? (
            liValues.map((liValue, index) => (
              <li key={ index } className={ liClassName }>
                <a
                  href={ liValue.href }
                  rel="noreferrer noopener"
                  >
                    { liValue.text }
                </a>
              </li>
            ))
          )
          : (
            <li
              className={ liClassName }
            >
              <a
                href={ liValues[0].href }
                rel="noreferrer noopener"
                >
                  { liValues[0].text }
              </a>
            </li>
          )
      }
    </ul>
  );
};

Ul.propTypes = {
  liClassName: PropTypes.string.isRequired,
  liValues: PropTypes.shape({
    href: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
  }),
  ulClassName: PropTypes.string.isRequired,
};

Ul.defaultProps = {
  liValues: PropTypes.shape({
    href: '',
    text: '',
  }),
};

export default Ul;
